import type { EditorPlugin } from '../../types';
import { getRenderLeaf } from '../../utils';
import { HeadingDecorationEditable } from './components';
import { getDecorate } from './decorate';
import { HEADING_DECORATION_PLUGIN_ID } from './types';
import type {
  HeadingDecorationPluginOptions,
  HeadingDecorationPluginPropertyOptions,
} from './types';

/**
 * RP-6005 (M2) — heading-as-decoration plugin. Renders heading-like paragraphs
 * (leading `Label:` run — see RP-6004 matcher) as headings WITHOUT persisting
 * anything. Modeled on `HighlightedPlugin`: `decorate` tags the label range and
 * `getRenderLeaf` styles any leaf carrying the tag.
 */
export const HeadingDecorationPlugin = ({
  component = HeadingDecorationEditable,
  pluginName = 'HeadingDecoration',
  headingLabels,
  ...rest
}: HeadingDecorationPluginOptions = {}): EditorPlugin => {
  const options: HeadingDecorationPluginPropertyOptions = {
    pluginID: HEADING_DECORATION_PLUGIN_ID,
    pluginName,
    component,
    headingLabels,
    ...rest,
  };

  return {
    pluginID: options.pluginID,
    renderLeaf: getRenderLeaf(options),
    decorate: getDecorate(options),
  };
};
